var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button"},[_c('button',{staticClass:"button__change",on:{"click":_vm.onClick}},[_c('span',{staticClass:"button__content"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n      "),_c('ion-icon',{attrs:{"name":"swap-horizontal-outline"}})],1)]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-752922d2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/buttons/btnChange.vue
// module id = 864
// module chunks = 0